module.exports = __webpack_public_path__ + "img/ru.bdfea20b.svg";